// | ------------------------------------------------------------------------
// | Contact
// | ------------------------------------------------------------------------ 

import validate from 'jquery-validation';

// | ------------------------------------------------------------------------ 

import "./components/jquery.magnific-popup";
import "./components/propertyMap";

$(".validateForm").validate();
// | ------------------------------------------------------------------------ 




